"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _createIconComponent = _interopRequireDefault(require("../utils/createIconComponent"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const ShirtIcon = (0, _createIconComponent.default)({
  content: ( /*#__PURE__*/_react.default.createElement("g", null, /*#__PURE__*/_react.default.createElement("path", {
    d: "M13.538 1.23H11.77l-.962-.96a.923.923 0 00-.632-.27H5.782a.923.923 0 00-.589.267l-.962.964H2.46A1.538 1.538 0 00.923 2.769v11.692A1.538 1.538 0 002.461 16h11.077a1.539 1.539 0 001.539-1.539V2.77a1.539 1.539 0 00-1.539-1.538zm-8 1.308l.114-.113L6.84 4.462 5.538 5.729V2.54zM8 2.785l-.547-.939h1.094L8 2.786zm2.461-.247v3.194L9.16 4.462l1.188-2.037.113.113zm-7.692.539h.923v3.385a1.538 1.538 0 002.622 1.093l.763-.747v7.346H2.769V3.077zm10.462 11.077H8.923V6.808l.763.745a1.539 1.539 0 002.622-1.091V3.077h.923v11.077z"
  })))
});
ShirtIcon.displayName = 'ShirtIcon';
var _default = exports.default = ShirtIcon;